<template>
  <div class="playlist-slide">
    <ImageSlide
      v-if="getSimpleType(slide.item_type) === 'image'"
      class="playlist-slide-image"
      :slide="slide"
    />

    <div v-else-if="getSimpleType(slide.item_type) === 'rss'" class="playlist-slide-app-rss">
      <RssViewer :setting="getRSSAppSettings(slide, slide.wid)" @saveData="saveAppData" />
    </div>

    <PlaylistLinkViewer
      v-else-if="getSimpleType(slide.item_type) === 'layer'"
      :slide="slide"
      :show="show"
    />

    <!-- Table app -->
    <div v-else-if="getSimpleType(slide.item_type) === 'table'" class="playlist-slide-app-table">
      <TableViewer v-if="show" :settings="slide" :is_visible="show" />
    </div>

    <div
      v-else-if="getSimpleType(slide.item_type) === APP_TYPES.TRAFIKLAB"
      class="playlist-slide-trafiklab-table"
    >
      <TrafiklabViewer
        :viewerStyles="slide.viewerStyles"
        :timetable="slide.timetable"
        :name="slide.timetable[0].stop.name"
        alt="Trafiklab app"
        @error="showPlaceholder = true"
        :app="slide"
        @saveData="saveAppData"
      />
    </div>

    <div
      v-else-if="getSimpleType(slide.item_type) === APP_TYPES.WEATHER"
      class="playlist-slide-weather-table"
    >
      <WeatherViewOld
        v-if="isOldWeatherApp"
        class="weather-app"
        :app="slide"
        @saveData="saveAppData"
      />
      <WeatherView v-else class="weather-app" :app="slide" @saveData="saveAppData" />
    </div>

    <div v-else-if="getSimpleType(slide.item_type) === 'pdf'" class="playlist-slide-pdf">
      <PdfView
        :pdfImages="slide.pdf_content.thumbnail_url"
        :imageMode="slide.imageMode"
        isPlaylistSlide
      />
    </div>

    <div v-else-if="getSimpleType(slide.item_type) === 'youtube'" class="player-slide-youtube">
      <YoutubeSlide :slide="slide" :isMuted="isMuted" />
    </div>

    <TemplateViewer
      v-else-if="show && getSimpleType(slide.item_type) === 'template'"
      :template="slide.template"
      :playlistId="playlist ? playlist.playlist_id : undefined"
    />

    <TileViewer
      v-else-if="getSimpleType(slide.item_type) === 'local-template'"
      :show="show"
      :tile="slide.template"
      :playlistId="playlist?.playlist_id"
    />

    <!-- Empty state  -->
    <div v-else />
  </div>
</template>

<script>
  import { simpleTypeMixin } from '@/helpers';
  import { APP_TYPES } from '@/models/layoutDesigner';
  import { CONTENT_TYPE_WEATHER_APP } from '@/constants';
  import { SET_APP_DATA } from '@/store/actions/player';

  import TableAppWebView from '@/components/tableApp/TableAppWebView.vue';
  import ImageSlide from '@/components/player/layerContent/ImageSlide.vue';
  import YoutubeSlide from '@/components/player/layerContent/YoutubeSlide.vue';
  import WeatherView from '@/components/apps/weather/WeatherView.vue';
  import WeatherViewOld from '@/components/apps/weather/WeatherViewOld.vue';
  import TrafiklabViewer from '@/components/common/timetable/TrafiklabViewer.vue';
  import PdfView from '@/components/content/PdfView.vue';
  import TemplateViewer from '@/components/widgets/templates/TemplateViewer.vue';
  import RssViewer from '@/components/rssViewer/RssViewer.vue';
  import TileViewer from '@/components/widgets/templates/TileViewer.vue';
  import PlaylistLinkViewer from '@/components/player/PlaylistLinkViewer.vue';

  export default {
    name: 'PlaylistSlide',

    mixins: [simpleTypeMixin],

    components: {
      RssViewer,
      TableViewer: TableAppWebView,
      ImageSlide,
      YoutubeSlide,
      WeatherView,
      WeatherViewOld,
      TrafiklabViewer,
      PdfView,
      TemplateViewer,
      TileViewer,
      PlaylistLinkViewer,
    },

    props: {
      slide: {
        type: Object,
        default: () => null,
      },
      show: {
        type: Boolean,
        default: false,
      },
      playlist: {
        type: Object,
        default: () => null,
      },
    },

    data() {
      return {
        APP_TYPES,
      };
    },

    computed: {
      iframeStyle() {
        return {
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
        };
      },

      isOldWeatherApp() {
        return (
          this.isWeatherApp &&
          !this.slide.weather &&
          (this.slide.visibility || this.slide.background)
        );
      },

      isWeatherApp() {
        return this.slide.item_type === CONTENT_TYPE_WEATHER_APP;
      },
    },

    methods: {
      isMuted(itemData) {
        if (this.isLoading && !itemData) {
          return true;
        }
        return itemData.mute;
      },

      saveAppData(data = null) {
        this.$store.commit(SET_APP_DATA, {
          appId: this.slide.wid,
          appData: { appType: this.slide.item_type, data },
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
